<template>
	<span style="display: flex; flex-direction: column; height: 50px; line-height: 20px">
		<span>{{ label }}</span>
		<el-input-number
			v-model="value"
			@change="InputChange"
			size="mini"
			:placeholder="placeholder"
			:precision="2"
			:step="0.1"
			:controls="false"
			style="width: 80%; height: 30px"
		></el-input-number>
		<!-- <el-input
				v-model.number="value"
				style="width: 80%;height: 30px;"
				@blur="InputChange"
				@change="InputChange"
				oninput="value=value.replace(/[^0-9.]/g,'')"
				size="mini"
				:placeholder="placeholder"
			></el-input> -->
	</span>
</template>

<script>
export default {
	props: ['bind', 'label', 'placeholder'],

	data() {
		return {
			value: undefined,
			Timenum: null,
		};
	},

	components: {},

	computed: {},

	methods: {
		InputChange(val) {
			if (val) {
				if (val) {
					this.$emit('valueChanged', val);
				}
				this.Timenum = setTimeout(() => {
					this.value = undefined;
				}, 500);
			}
		},
	},
	destroyed() {
		clearTimeout(this.Timenum);
	},
};
</script>

<style lang="scss" scoped></style>
